var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 20 20)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#0F0",
    strokeWidth: 3,
    cx: 20,
    cy: 20,
    r: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 19.3L19 11.58 17.59 13l6 6H13c-.55 0-.55 2 0 2h10.59l-6 6L19 28.41l7.7-7.7a1 1 0 000-1.42z",
    fill: "#0F0",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMjAgMjApIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgc3Ryb2tlPSIjMEYwIiBzdHJva2Utd2lkdGg9IjMiIGN4PSIyMCIgY3k9IjIwIiByPSIxOC41Ii8+PHBhdGggZD0iTTI2LjcgMTkuM0wxOSAxMS41OCAxNy41OSAxM2w2IDZIMTNjLS41NSAwLS41NSAyIDAgMmgxMC41OWwtNiA2TDE5IDI4LjQxbDcuNy03LjdhMSAxIDAgMDAwLTEuNDJ6IiBmaWxsPSIjMEYwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L2c+PC9zdmc+";
export { SvgArrowDownGreen as ReactComponent };